<template>
  <div id="app">
    <!-- 区域选择页不显示 Header/Footer -->
    <Header v-if="showLayout" />

    <router-view/>

    <Footer v-if="showLayout" />

    <div class="overlay" :class="{ active: isMenuOpen }" @click="closeMenu"></div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import { useRegion } from './composables/useRegion.js'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      isMenuOpen: false,
      currentLanguage: localStorage.getItem('language') || 'zh'
    }
  },
  computed: {
    showLayout() {
      // 根路径（区域选择页）不显示 Header/Footer
      return this.$route.path !== '/'
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    },
    changeLanguage() {
      this.$i18n.locale = this.currentLanguage
      localStorage.setItem('language', this.currentLanguage)
    }
  },
  watch: {
    '$route'() {
      this.closeMenu()
    }
  },
  created() {
    const savedLanguage = localStorage.getItem('language') || this.$i18n.locale
    if (savedLanguage) {
      this.currentLanguage = savedLanguage
      this.$i18n.locale = savedLanguage
    }
  }
}
</script>

<style>
body {
  background-color: #f5fdfd;
  font-family: 'Arial', sans-serif;
  color: #333;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 4;
}

.overlay.active {
  opacity: 1;
  visibility: visible;
}

@media screen and (max-width: 768px) {
  .nav-container {
    padding: 0 20px;
  }

  .menu-toggle {
    display: flex;
  }

  .nav-menu {
    position: fixed;
    right: 0;
    top: 0;
    width: 250px;
    height: 100%;
    background-color: #1a1a1a;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 80px;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    z-index: 5;
  }

  .nav-menu.active {
    transform: translateX(0);
  }

  .nav-item {
    height: auto;
    margin: 10px 0;
    width: 100%;
    text-align: center;
  }

  .language-switcher {
    padding: 1rem;
  }

  .hero-content h1 {
    font-size: 2rem;
  }

  .hero-content p {
    font-size: 1rem;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 480px) {
  .nav-container {
    flex-direction: row;
    padding: 0 15px;
  }

  .nav-logo {
    margin-bottom: 0;
  }

  .navbar {
    height: 60px;
    padding: 0;
  }

  .nav-item {
    margin: 5px 0;
  }

  .hero-content h1 {
    font-size: 1.5rem;
  }

  .features-section h2 {
    font-size: 2rem;
  }

  .feature-card {
    padding: 20px;
  }
}
</style>
